module.exports = __webpack_public_path__ + "static/img/default-avatar.e694e6ba.png";